import ReactDOM from 'react-dom/client';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-dropzone-uploader/dist/styles.css';
import 'react-month-picker/scss/month-picker.scss';
import 'react-month-picker/css/month-picker.css';
import './i18n';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);
